import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { TierId } from "../pages/PricingPage";

type ConfirmUpgradePopupProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  tierId: TierId | null;
  message?: string;
};

export default function ConfirmUpgradePopup({
  isOpen,
  onClose,
  onConfirm,
  tierId,
  message = `You're about to switch to the ${tierId?.toUpperCase()} tier. Please confirm that you understand this may incur charges if you're upgrading your subscription.`,
}: ConfirmUpgradePopupProps) {


  return (
    <Dialog open={isOpen} onClose={onClose} aria-labelledby="usage-limit-dialog-title" maxWidth="xs" fullWidth>
      <DialogTitle id="usage-limit-dialog-title">Confirm Switch</DialogTitle>
      <DialogContent>
        <Typography variant="body1" color="textSecondary">
          {message}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button style={{borderColor:'black', color:'black'}} variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button style={{backgroundColor:'black'}} variant="contained" color="primary" onClick={onConfirm}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
